// extracted by mini-css-extract-plugin
module.exports = {"user-role":"user-role_user-role__CQSlf"};